<template>
  <el-dialog
    title="预览"
    width="70%"
    :visible.sync="diaLoading"
    :modal="false"
    :append-to-body="appendToBod"
    @close="onCloseDia"
  >
    <iframe
      v-if="value"
      :src="value"
      frameborder="0"
      class="iframe"
      :style="{ height: height, width: width }"
    ></iframe>
    <span slot="footer">
      <el-button type="primary" @click="onCloseDia">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "",
    },
    appendToBod: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.diaLoading = true;
      } else {
        this.diaLoading = false;
      }
    },
  },
  data() {
    return {
      diaLoading: false,
    };
  },
  methods: {
    onCloseDia() {
      this.diaLoading = false;
      this.$emit("input", "");
    },
  },
};
</script>

<style>
.iframe {
  width: 100%;
  height: 400px;
}
</style>